import { render } from "./Stays.vue?vue&type=template&id=35daddbd&scoped=true"
import script from "./Stays.vue?vue&type=script&lang=js"
export * from "./Stays.vue?vue&type=script&lang=js"

import "./Stays.vue?vue&type=style&index=0&id=35daddbd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35daddbd"]])

export default __exports__